import React, { useState } from "react";
import { Circle, Text } from "@networkraildigitalfactory/components";
import { CaretDown, CaretUp } from "phosphor-react";
import Collapse from "@kunukn/react-collapse";
import styles from "./CollapsibleObjectiveDetails.module.css";
import { isNotSafetyPromise } from "../ValuesSelect/ValuesSelect";

const CollapsibleObjectiveDetails = (props) => {
  const { objectiveDetails, isGBREmployee, isOpen } = props;
  const {
    name,
    value,
    additionalComments,
    objectiveDetail,
    actionPlan,
    whatIsSuccess,
  } = objectiveDetails;
  const [isCollapsed, setIsCollapsed] = useState(isOpen);

  const toggleCollapsedDetails = () => {
    setIsCollapsed(!isCollapsed);
  };

  const objectiveDetailLabel = isNotSafetyPromise(value)
    ? "What’s the objective / goal?"
    : "What’s your Safety Promise";

  const whatIsSuccessInfo = isNotSafetyPromise(value) ? (
    <>
      <Text wrapper="span" type="body" style={{ color: "#000000" }}>
        What will success look like?
      </Text>
      <Text wrapper="p" type="body">
        {whatIsSuccess}
      </Text>
    </>
  ) : null;

  return (
    <>
      <div className={styles.collapsable_objecitve_button}>
        <div
          className={styles.collapsable_objecitve_button_clickable}
          role="button"
          aria-label="Expand objective details"
          aria-expanded={isCollapsed}
          name={`toggle${name}`}
          tabIndex={0}
          onClick={toggleCollapsedDetails}
          onKeyDown={(e) => (e.key === "Enter" ? toggleCollapsedDetails() : undefined)}
        >
          <Text wrapper="h2" type="header" style={{ fontSize: "20px" }}>
            {name || "PLACEHOLDER NAME"}
          </Text>

          <Circle color="#37519D" size={20}>
            {isCollapsed ? (
              <CaretUp size={16} color="white" />
            ) : (
              <CaretDown size={16} color="white" />
            )}
          </Circle>
        </div>
      </div>
      <Collapse isOpen={isCollapsed} transition="height 0.3s cubic-bezier(.4, 0, .2, 1)">
        <div className={styles.collapsable_objecitve_data}>
          <Text wrapper="span" type="body" style={{ color: "#000000" }}>
            {isGBREmployee ? "GBRTT strategic goal" : "Network Rail vision statement"}
          </Text>
          <Text wrapper="p" type="body">
            {value}
          </Text>
          <Text wrapper="span" type="body" style={{ color: "#000000" }}>
            {objectiveDetailLabel}
          </Text>
          <Text wrapper="p" type="body">
            {objectiveDetail}
          </Text>
          <Text wrapper="span" type="body" style={{ color: "#000000" }}>
            What’s your action plan? How will you achieve this?
          </Text>
          <Text wrapper="p" type="body">
            {actionPlan}
          </Text>
          {whatIsSuccessInfo}
          {additionalComments !== "" && (
            <div>
              <Text wrapper="span" type="body" style={{ color: "#000000" }}>
                Additional Comments
              </Text>
              <Text wrapper="p" type="body">
                {additionalComments}
              </Text>
            </div>
          )}
        </div>
      </Collapse>
    </>
  );
};

export default CollapsibleObjectiveDetails;
